import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchPatientEdiary = async ({ patientId, trialId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(
    `${__API_URL__}/api/photos/ediary/patient/${patientId}/?trial_id=${trialId}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useGetPatientEdiary = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["patient_ediary", patientId, trialId],
    queryFn: () => fetchPatientEdiary({ patientId, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load eDiary");
    },
  });
};

export default useGetPatientEdiary;
